var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0909424,
    width: 40,
    height: 40,
    rx: 20,
    className: "ext4_1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2885_13601)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext4_1_i",
    d: "M19.6518 21.8975C19.6518 22.5064 19.1582 23 18.5493 23C17.9404 23 17.4468 22.5064 17.4468 21.8975C17.4468 21.2886 17.9404 20.795 18.5493 20.795C19.1582 20.795 19.6518 21.2886 19.6518 21.8975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext4_1_i",
    d: "M22.6105 10.7465C21.9729 10.0702 20.918 10.0419 20.2429 10.6784C19.5756 11.3076 19.5392 12.3431 20.15 13.0191C19.735 13.7257 19.4704 14.5313 19.4004 15.392L19.3912 15.3822L9.44093 27.0455C9.12794 27.4145 8.92706 27.8654 8.86201 28.3448C8.79696 28.8243 8.87046 29.3124 9.07382 29.7515C9.27719 30.1905 9.60194 30.5623 10.0097 30.8227C10.4175 31.0832 10.8913 31.2216 11.3752 31.2215C11.925 31.2216 12.4597 31.0411 12.8969 30.7077L25.1212 21.4572L25.1176 21.4534C25.9828 21.4332 26.7995 21.2169 27.5249 20.8471L27.6297 20.9584C28.2671 21.6343 29.3212 21.6631 29.9964 21.0276C30.6755 20.3959 30.7006 19.3327 30.0656 18.6591L29.9203 18.5049C30.3455 17.7153 30.5867 16.8121 30.5867 15.8525C30.5867 12.7583 28.0784 10.25 24.9842 10.25C24.1434 10.25 23.3457 10.4352 22.63 10.7671L22.6105 10.7465ZM19.4474 17.6277L19.816 18.019C20.3401 19.2677 21.3035 20.2864 22.5128 20.8818L22.8832 21.275L11.9902 29.5167C11.7868 29.6729 11.5326 29.7478 11.2771 29.7269C11.0215 29.7061 10.7829 29.5909 10.6076 29.4038C10.4323 29.2167 10.3328 28.971 10.3286 28.7147C10.3243 28.4583 10.4156 28.2095 10.5847 28.0167L19.4474 17.6277ZM20.7574 11.2241C21.1323 10.8706 21.7125 10.8873 22.0648 11.261L29.5197 19.1734C29.8744 19.5495 29.8548 20.1356 29.485 20.4789L29.4829 20.4809C29.108 20.8344 28.528 20.8177 28.1756 20.4441L20.7206 12.5316C20.3671 12.1567 20.3837 11.5765 20.7574 11.2241Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2885_13601"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1_i",
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.09094 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.a2796a5c.svg";
export { ForwardRef as ReactComponent };